const DeleteSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            style={{ cursor: "pointer" }}
            fill="red"
            viewBox="0 0 24 24"
        >
            <path d="M3 6h18v2H3zm2 3h14l-1 12H6zm3-6h6v2H9z" />
        </svg>
    )
}

export default DeleteSvg;